module.exports = __webpack_public_path__ + "img/CTS.bc6d1597.jpg";